




import { FaFileUpload } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
import ASearch from '../../organisms/ASearch';

import PageList from '../../templates/PageList';

import { BATCH_ANALYSIS_LIST } from '../../organisms/TwoSidebar';
import NewTooltip from '../../atoms/NewTooltip';

type BlockListProcessed = {
    id: string;
    date: string;
    operation: string;
    username: string;
    filename: number;
    success_count: string;
    invalid_count: String;
    error_count: String;
    total_count: string;
    status: string;
}

// Quando o ambiente é de produção, usamos uma URL fixa
const BASE_URL = process.env.REACT_APP_NODE_ENV === 'prd'
    ? 'https://ywtmfwiu2h.execute-api.us-east-1.amazonaws.com/v1/blocklist/file'
    : `${process.env.REACT_APP_API_GATEWAY_BLOCKLIST_URL}/blocklist/file`;

const BlockListPage = () => {

    const navigate = useNavigate();

    const { page, pageSize, field: fieldSorted,
        order: orderSorted, filter }: any = useParams();

    let txtPartnerName = '';
    let txtStatus = '';
    let txtFilename = '';

    if (filter)
        [txtFilename = '', txtStatus = '', txtPartnerName = ''] = filter.match(/=(.*?);/g)
            .map((match: string | any[]) => match.slice(1, -1));

    const url = BASE_URL + `?search=${txtFilename}`
        + `&page=${page}&pageSize=${pageSize}`;

    const getCssColorBy = (status: string | undefined) => {
        if (!status) return 'bg-gray-800';

        const cssClazz: Record<string, string> = {
            'PROCESSING': 'bg-blue-500',
            'ERROR': 'bg-red-500',
            'PROCESSED': 'bg-green-500'
        }
        return cssClazz[status.toUpperCase()];
    };

    const getCssColorByOperation = (operation: string | undefined) => {
        if (!operation) return 'bg-gray-800';

        const cssClazz: Record<string, string> = {
            'DEL': 'bg-red-500',
            'ADD': 'bg-green-500'
        }
        return cssClazz[operation.toUpperCase()];
    };

    const getContentByStatus = (status: string) => {
        const statusTable = {
            "PROCESSING": "Em processamento",
            "ERROR": "Erro ao processar",
            "PROCESSED": "Processado com sucesso",
        };

        return statusTable[status as keyof typeof statusTable] || "Status desconhecido";
    };

    const getTranslatedStatus = (status: string) => {
        const statusTable = {
            "PROCESSING": "Processando",
            "ERROR": "Erro",
            "PROCESSED": "Processado",
        };

        return statusTable[status as keyof typeof statusTable] || "Status desconhecido";
    };

    const getContentByOperation = (operation: string) => {
        const operationTable = {
            "ADD": "Operação de inclusão",
            "DEL": "Operação de exclusão",
        };

        return operationTable[operation as keyof typeof operationTable] || "Operação desconhecida";
    };

    const renderRows = (rows: BlockListProcessed[]) => {

        if (!rows || rows.length === 0) {
            return (
                <tr>
                    <td colSpan={9} className="py-2 px-2 text-center">
                        <div className="text-2xl font-bold text-gray-500 mt-4">
                            Nenhum registro encontrado...
                        </div>
                    </td>
                </tr>
            );
        }

        return rows.map((row: BlockListProcessed, index: number) => (
            <tr key={row.id}
                className={`${index % 2 === 0 ? 'bg-slate-100' : ''} hover:bg-slate-300 hover:shadow-md border-b border border-gray-300 cursor-pointer`}>
                <td className="py-2 px-2">{row.id}</td>
                <td className="py-2 px-2" align='center'>{new Date(row.date).toLocaleDateString('pt-BR')}</td>
                <td className="py-2 px-2 max-w-0" align='center'>
                    <NewTooltip content={getContentByOperation(row.operation.toUpperCase())} alignment="left">
                        <span className={`rounded px-1 py-1 text-xs font-bold text-white ${getCssColorByOperation(row.operation)}`}>
                            {row.operation}
                        </span>
                    </NewTooltip>
                </td>
                <td className="py-2 px-2 truncate max-w-0">
                    {row.username}
                </td>
                <td className="py-2 px-2 truncate max-w-0">
                    {row.filename}
                </td>

                <td className="py-2 px-2" align="center">
                    {row.success_count}
                </td>

                <td className="py-2 px-2" align="center">
                    {row.invalid_count}
                </td>

                <td className="py-2 px-2" align="center">
                    {row.error_count}
                </td>

                <td className="py-2 px-2" align="center">
                    {row.total_count}
                </td>

                <td className="py-2 px-2" align="center">
                    <NewTooltip content={getContentByStatus(row.status.toUpperCase())} alignment="left">
                        <span className={`rounded px-1 py-1 text-xs font-bold text-white ${getCssColorBy(row.status)}`}>
                            {getTranslatedStatus(row.status.toUpperCase())}
                        </span>
                    </NewTooltip>

                </td>
            </tr>
        ));
    }

    const pageChanged = (page: number) => {
        page = page - 1;
        navigate(urlNavigate(page, pageSize, fieldSorted, orderSorted, txtFilename, txtStatus, txtPartnerName), { replace: true });
    }

    const pageSizeChanged = (pageSize: number) => {
        navigate(urlNavigate(0, pageSize, fieldSorted, orderSorted, txtFilename, txtStatus, txtPartnerName), { replace: true });
    }

    const pageSorted = (field: keyof BlockListProcessed | string, order: 'ASC' | 'DESC') => {
        navigate(urlNavigate(page, pageSize, field, order, txtFilename, txtStatus, txtPartnerName), { replace: true });
    }

    const txtFileNameChange = (fileName: string) => {
        navigate(urlNavigate(0, pageSize, fieldSorted, orderSorted, fileName, txtStatus, txtPartnerName), { replace: true });
    }

    const txtPartnerNameClick = (partnerName: string) => {
        navigate(urlNavigate(0, pageSize, fieldSorted, orderSorted, txtFilename, txtStatus, partnerName), { replace: true });
    }

    const filterStatusChange = (status: string) => {
        navigate(urlNavigate(0, pageSize, fieldSorted, orderSorted, txtFilename, status, txtPartnerName), { replace: true });
    }

    const onFilterClean = () => {
        txtPartnerName = '';
        txtStatus = '';
        txtFilename = '';
        navigate(urlNavigate(0, pageSize, fieldSorted, orderSorted, '', '', ''), { replace: true });
    }

    const urlNavigate = (page: number, pageSize: number, fieldSorted: string, orderSorted: string,
        fileName: string, status: string, partnerName: string) => {
        return `${BATCH_ANALYSIS_LIST}/${page}/${pageSize}/${fieldSorted}/${orderSorted}/fn=${fileName};a=${status};p=${partnerName};`
    }

    const newBlockListFileInput = () => {
        navigate("/blocklist/file-input/form");
    }

    return (

        <PageList
            pageTitle='Blocklist'
            url={url}
            breadcrumb={[{ label: 'Arquivos da blocklist', url: "#" }]}
            tableFieldSort={fieldSorted}
            tableOrderSort={orderSorted}
            onTableSort={pageSorted}
            renderRows={renderRows}
            page={page}
            pageSize={pageSize}
            onPageChange={pageChanged}
            onItemsPerPageChange={pageSizeChanged}
            itemsLabel='blocklist'
            defaultBackendHeader={false}
            aTableMarginTopDefault={136}
            tableHeaders={[{
                id: "col-id",
                title: "#",
                field: "id",
                canSort: true,
                width: "70px"
            },
            {
                id: "col-data",
                title: "Data",
                canSort: false,
                cssClass: "px-2",
                width: "90px",
            },
            {
                id: "col-operacao",
                title: "Operação",
                canSort: false,
                cssClass: "px-2",
                width: "120px",
                headerTooltipDescription: "Adição ou remoção",
            },
            {
                id: "col-usuario",
                title: "Usuário",
                canSort: false,
                cssClass: "text-left px-2",
                headerTooltipDescription: "Usuário do backoffice que fez a ação",
            },
            {
                id: "col-arquivo",
                title: "Arquivo",
                canSort: false,
                cssClass: "text-left px-2",
                headerTooltipDescription: "Nome do arquivo enviado",
            },
            {
                id: "col-sucessos",
                title: "Sucessos",
                canSort: false,
                cssClass: "px-2",
                width: "100px",
                headerTooltipDescription: "CPFs/CNPJs adicionados/removidos com sucesso",
            },
            {
                id: "col-invalidos",
                title: "Inválidos",
                canSort: false,
                cssClass: "px-2",
                width: "100px",
                headerTooltipDescription: "inclui CPFs/CNPJs inválidos, CPFs/CNPJs enviados sem motivo e CPFs/CNPJs já existentes na blocklist (para adição) ou CPFs/CNPJs inexistentes na blocklist (para remoção)",
            },
            {
                id: "col-erros",
                title: "Erros",
                canSort: false,
                cssClass: "px-2",
                width: "100px",
                headerTooltipDescription: "CPFs/CNPJs com erro para adicionar/remover",
            },
            {
                id: "col-total",
                title: "Total",
                canSort: false,
                cssClass: "px-2",
                width: "100px",
            },
            {
                id: "col-status",
                title: "Status",
                canSort: false,
                cssClass: "px-2",
                width: "120px",
            }]}
        >
            {{
                filterSlot: (
                    <div className="grid grid-cols-12 gap-1"> </div>),
                controlSlot: (
                    <div className='pt-4' >
                        <button type='button'
                            className='text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm px-5 py-2.5 text-center mr-2 mb-2'
                            onClick={newBlockListFileInput}>
                            <div className="flex items-center">
                                <FaFileUpload className='mr-2' />
                                Alterar Blocklist
                            </div>
                        </button>
                    </div>
                )
            }}
        </PageList >
    );
};

export default BlockListPage;
